"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.providers = exports.ProviderStack = void 0;
const react_1 = __importDefault(require("react"));
/**
 * Renders all configured providers in order
 * @param children react children
 * @param providers The providerStack
 * @constructor
 */
function ProviderStack({ children, providers, }) {
    var _a;
    const provider = (_a = providers.providers) === null || _a === void 0 ? void 0 : _a.reduceRight((cur, [Provider, props]) => {
        return react_1.default.createElement(Provider, Object.assign({}, props), cur);
    }, react_1.default.createElement(react_1.default.Fragment, null, children));
    return react_1.default.createElement(react_1.default.Fragment, null, provider);
}
exports.ProviderStack = ProviderStack;
/**
 * Creates a ProviderStack.
 * On the provider Stack you can add new providers with `.add(Provider)`
 */
function providers() {
    return stack([]);
}
exports.providers = providers;
function stack(currentProviders) {
    return {
        add: function (provider, props) {
            // @ts-ignore
            return stack([...(currentProviders !== null && currentProviders !== void 0 ? currentProviders : []), [provider, props]]);
        },
        providers: currentProviders !== null && currentProviders !== void 0 ? currentProviders : [],
    };
}
//# sourceMappingURL=index.js.map